import React from 'react';
import styled from 'styled-components';

const CopyrightContainer = styled.span`
  color: ${({ theme }) => theme.palette.navyGrayDarken5};
  font-size: 1.2rem;

  ${({ theme }) => theme.breakpoints.maxTablet} {
    line-height: 2;
  }
`;

const Copyright = () => (
  <CopyrightContainer>{`© ${new Date().getFullYear()} MARKEDWAY Limited, All rights reserved.`}</CopyrightContainer>
);

export default Copyright;
